<script>

    import InputText from './input.text.svelte'

    export let value = null

</script>

<div class="columns">
    <div class="column">
        <InputText bind:value on:enter icon="search" placeholder="Buscar" />
    </div>
    <slot></slot>
</div>